/**
 * sticky-atc.js — Shopify Dawn Theme
 *
 * Strategy: instead of re-implementing cart logic, the sticky bar SYNCS the
 * variant + quantity onto the page's real product form and then CLICKS the
 * theme's own buttons. That way Dawn's native code handles the cart drawer
 * refresh, and Shiprocket handles Buy Now exactly like the main button does.
 */

(function () {
  'use strict';

  function init() {
    const bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;

    const addBtn         = document.getElementById('sticky-atc-btn');
    const buyBtn         = document.getElementById('sticky-buy-btn');
    const soldOutEl      = document.getElementById('sticky-sold-out');
    const priceEl        = document.getElementById('sticky-atc-price');
    const imageEl        = document.getElementById('sticky-atc-image');
    const qtyInput       = document.getElementById('sticky-qty-input');
    const qtyMinus       = document.getElementById('sticky-qty-minus');
    const qtyPlus        = document.getElementById('sticky-qty-plus');
    const variantSelects = document.querySelectorAll('.sticky-atc__variant-select');

    const allVariants    = window.stickyATCVariants || [];
    const variantImages  = window.stickyATCProductImages || {};
    const defaultImage   = window.stickyATCDefaultImage || '';

    const mainForm = document.querySelector('form[action*="/cart/add"]');

    // -- Scroll: show bar when original form is off-screen --
    function checkScroll() {
      if (!mainForm) { bar.classList.add('is-visible'); return; }
      const rect = mainForm.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }
    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();

    // -- Get selected variant from sticky dropdowns --
    function getSelectedVariant() {
      if (!variantSelects.length) return allVariants[0] || null;
      const selectedOptions = Array.from(variantSelects).map(s =>
        s.value.replace(/^[^:]+:\s*/, '').trim()
      );
      return allVariants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      ) || null;
    }

    // -- Format money --
    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-IN',
          { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR' }
        ).format(cents / 100);
      } catch (e) { return '\u20B9' + (cents / 100).toFixed(2); }
    }

    // -- Update image --
    function updateImage(variant) {
      if (!imageEl) return;
      const newSrc = (variant && variantImages[variant.id]) || defaultImage;
      if (!newSrc) return;
      if (imageEl.src.includes(newSrc.split('?')[0].split('/').pop())) return;
      imageEl.classList.add('is-loading');
      const img = new Image();
      img.onload = () => { imageEl.src = newSrc; imageEl.classList.remove('is-loading'); };
      img.onerror = () => imageEl.classList.remove('is-loading');
      img.src = newSrc;
    }

    // -- Update UI --
    function updateUI(variant) {
      const available = variant && variant.available;
      if (available) {
        if (addBtn) { addBtn.disabled = false; addBtn.style.display = ''; }
        if (buyBtn) { buyBtn.disabled = false; buyBtn.style.display = ''; }
        if (soldOutEl) soldOutEl.style.display = 'none';
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.style.display = 'none'; }
        if (buyBtn) { buyBtn.disabled = true; buyBtn.style.display = 'none'; }
        if (soldOutEl) soldOutEl.style.display = 'flex';
      }
      if (variant && priceEl) {
        let html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
        }
        html += formatMoney(variant.price);
        priceEl.innerHTML = html;
      }
      if (variant) {
        if (addBtn) addBtn.dataset.variantId = variant.id;
        if (buyBtn) buyBtn.dataset.variantId = variant.id;
      }
      updateImage(variant);
    }

    // -- Sticky -> main page variant sync --
    variantSelects.forEach(select => {
      select.addEventListener('change', () => {
        const variant = getSelectedVariant();
        updateUI(variant);
        if (!variant) return;
        const idx = select.dataset.optionIndex;
        const cleanValue = select.value.replace(/^[^:]+:\s*/, '').trim();

        document.querySelectorAll(
          'variant-selects select[data-option-index="' + idx + '"],' +
          '.product-form__input select[data-option-index="' + idx + '"]'
        ).forEach(mainSel => {
          if (mainSel.value !== cleanValue) {
            mainSel.value = cleanValue;
            mainSel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        document.querySelectorAll(
          'variant-selects input[type="radio"][data-option-index="' + idx + '"],' +
          'variant-radios input[type="radio"][data-option-index="' + idx + '"]'
        ).forEach(radio => {
          if (radio.value === cleanValue && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    // -- Main page -> sticky sync --
    document.addEventListener('change', function (e) {
      const t = e.target;
      if (!t) return;
      const isMainVariant = t.closest('variant-selects') || t.closest('variant-radios') || t.closest('.product-form__input');
      if (!isMainVariant) return;
      const idx = t.dataset.optionIndex;
      if (idx === undefined) return;
      const stickySelect = document.querySelector('.sticky-atc__variant-select[data-option-index="' + idx + '"]');
      if (!stickySelect) return;
      const optionName = (stickySelect.options[0] && stickySelect.options[0].text.split(':')[0].trim()) || '';
      const newStickyValue = optionName + ': ' + t.value;
      if (stickySelect.value !== newStickyValue) stickySelect.value = newStickyValue;
      updateUI(getSelectedVariant());
    });

    document.addEventListener('variant:change', function (e) {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;
      variantSelects.forEach(select => {
        const idx = parseInt(select.dataset.optionIndex, 10);
        const optionName = (select.options[0] && select.options[0].text.split(':')[0].trim()) || '';
        const newValue = optionName + ': ' + variant.options[idx];
        if (select.value !== newValue) select.value = newValue;
      });
      updateUI(variant);
    });

    // -- Quantity controls --
    if (qtyMinus) qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      if (v < 99) qtyInput.value = v + 1;
    });
    if (qtyInput) qtyInput.addEventListener('change', () => {
      let v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 99) v = 99;
      qtyInput.value = v;
    });

    // -- Sync variant + qty onto the real product form --
    function syncMainForm(variantId, qty) {
      const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
      if (idInput) {
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const qtyInputs = document.querySelectorAll(
        'form[action*="/cart/add"] input[name="quantity"], quantity-input input[name="quantity"], .quantity__input'
      );
      qtyInputs.forEach(q => {
        q.value = qty;
        q.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // -- Find + click the theme's native ADD button --
    function clickNativeAdd() {
      const btn = document.querySelector(
        'product-form button[name="add"], ' +
        'form[action*="/cart/add"] button[type="submit"][name="add"], ' +
        'form[action*="/cart/add"] button[type="submit"], ' +
        '.product-form__submit'
      );
      if (btn) { btn.click(); return true; }
      return false;
    }

    // -- Find + click the Shiprocket / native Buy Now button --
    function clickNativeBuyNow() {
      const selectors = [
        'button.sr-headless-checkout',
        '.sr-headless-checkout',
        '[data-sr-headless-checkout]',
        '.shiprocket-checkout-btn',
        '.sr-buy-now-btn',
        '#sr-checkout-button',
        '.shopify-payment-button__button',
        'button[name="checkout"]'
      ];
      for (let i = 0; i < selectors.length; i++) {
        const el = document.querySelector(selectors[i]);
        if (el) { el.click(); return true; }
      }
      return false;
    }

    // -- Fallback: direct add (only if native button missing) --
    async function fallbackAdd(variantId, qty, redirect) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Add failed');
        }
        window.location.href = redirect ? '/checkout' : '/cart';
      } catch (e) {
        console.error('[sticky-atc] fallback add failed:', e);
        alert('Sorry, could not add to cart. Please use the main button.');
      }
    }

    // -- Add to Cart --
    if (addBtn) addBtn.addEventListener('click', function () {
      const self = this;
      const variantId = parseInt(self.dataset.variantId, 10);
      const qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      if (!variantId) { console.warn('[sticky-atc] no variant id'); return; }

      const original = self.innerText;
      self.disabled = true;
      self.innerText = 'Adding...';

      syncMainForm(variantId, qty);

      setTimeout(function () {
        const clicked = clickNativeAdd();
        if (!clicked) {
          console.warn('[sticky-atc] native Add button not found, using fallback');
          fallbackAdd(variantId, qty, false);
        }
        setTimeout(function () { self.disabled = false; self.innerText = original; }, 1500);
      }, 120);
    });

    // -- Buy Now (Shiprocket) --
    if (buyBtn) buyBtn.addEventListener('click', function () {
      const self = this;
      const variantId = parseInt(self.dataset.variantId, 10);
      const qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      if (!variantId) return;

      const original = self.innerText;
      self.disabled = true;
      self.innerText = 'Please wait...';

      syncMainForm(variantId, qty);

      setTimeout(function () {
        const clicked = clickNativeBuyNow();
        if (!clicked) {
          console.warn('[sticky-atc] Buy Now button not found - share the main BUY NOW button HTML so I can add its class.');
          fallbackAdd(variantId, qty, true);
        }
        setTimeout(function () { self.disabled = false; self.innerText = original; }, 1500);
      }, 120);
    });

    // -- Init --
    updateUI(getSelectedVariant());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
